import { useState } from 'react';
import axios from 'axios';

const useFetchLatePayments = () => {
  const [loadingLatePayments, setLoadingLatePayments] = useState(false);
  const [errorLatePayments, setErrorLatePayments] = useState(null);

  const fetchLatePayments = async () => {
    try {
      setLoadingLatePayments(true);
      setErrorLatePayments(null);

      const response = await axios.get(`/api/LandingWarehouse/NetSuite/SavedSearch/LatePayments`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      setErrorLatePayments(err instanceof Error ? err.message : 'An error occurred');
      throw err;
    } finally {
      setLoadingLatePayments(false);
    }
  };

  const fetchLatePaymentsForPie = async () => {
    try {
      setLoadingLatePayments(true);
      setErrorLatePayments(null);

      const response = await axios.get(`/api/LandingWarehouse/NetSuite/SavedSearch/LatePayments`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data.map((item) => ({
        ...item,
        invoiceProcessing: item.invoiceProcessing ?? item.invoiceProcessingStatus,
        approvals: item.approvals ?? item.approvalStatus,
        paymentProcessing: item.paymentProcessing ?? item.paymentProcessingStatus,
      }));
    } catch (err) {
      setErrorLatePayments(err instanceof Error ? err.message : 'An error occurred');
      throw err;
    } finally {
      setLoadingLatePayments(false);
    }
  };

  return { fetchLatePayments, fetchLatePaymentsForPie, loadingLatePayments, errorLatePayments };
};

export default useFetchLatePayments;
